module.exports = __webpack_public_path__ + "files/b73f4e81713e6dff500487f92b7771dd.png";